import { render, staticRenderFns } from "./TrialAddUpdate.vue?vue&type=template&id=a3311718&"
import script from "./TrialAddUpdate.vue?vue&type=script&lang=js&"
export * from "./TrialAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports